import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "inhdialog-header" }
const _hoisted_2 = { class: "dialog_name" }
const _hoisted_3 = { class: "dialog_content" }
const _hoisted_4 = {
  key: 0,
  class: "inner_container q-mx-sm"
}
const _hoisted_5 = {
  key: 1,
  class: "inner_container q-mx-sm"
}
const _hoisted_6 = { class: "inhdialog-header" }
const _hoisted_7 = { class: "dialog_name" }
const _hoisted_8 = { class: "dialog_content" }
const _hoisted_9 = {
  key: 0,
  style: {"text-align":"center","margin-top":"20px","margin-bottom":"20px","width":"100%"}
}

import { reactive, ref } from "vue";
import { CellDataIdListEntityType } from "@/models/etc/types";
import type {
  AnalyticsResultTableExtended,
  JobLight,
  PersonInList,
} from "@/models/interfaces/entity-settings/querytable/querytable";
import type { PaginationProps } from "@/models/base/common.selector";
import { auxStore } from "@/store/auxillary";
import { settingsStore } from "@/store/settings";
import { BaseItemTypes } from "@/components/dnd/ItemTypes";
import JobCard from "../../item-cards/JobCard.vue";
import PersonCard from "../../item-cards/PersonCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SourceItemsDialog',
  setup(__props, { expose: __expose }) {

const aux = auxStore();
const setstore = settingsStore();

const sourceItemsDisplay = ref(false);
const sourceTableDisplay = ref(false);
const source_jobs = ref<JobLight[]>([]);
const source_contacts = ref<PersonInList[]>([]);
const entity_ids = ref<number[]>([]);
const entity_type = ref<CellDataIdListEntityType>(0);
const sourceTableModel = ref<AnalyticsResultTableExtended>({} as AnalyticsResultTableExtended);
const projectionParentEl = ref<any>(undefined);
const pagination = reactive({} as PaginationProps);
const selectedEntities = ref<number[]>([]);
const unselectedEntities = ref<number[]>([]);
const selectedAll = ref<string>("");

function resetPagination() {
  Object.assign(pagination, {
    count: 0,
    offset: 0,
    recalculate: false,
    sortMode: 0,
    OrderByPinned: false,
    sortCategory: 0,
    report: false,
    total_count: 0,
    report_index: -1,
  });
}

async function getSourceItems(ids: number[], type: CellDataIdListEntityType) {
  entity_type.value = type;
  projectionParentEl.value = undefined;

  if (
    type === CellDataIdListEntityType.StorageItems ||
    type === CellDataIdListEntityType.StorageItemMovements
  ) {
    const chain = setstore.getProjectionParentChain;
    if (chain && chain.length) {
      projectionParentEl.value = {
        Id: chain[0].Identity.ElementId,
        elType:
          chain[0].Source !== undefined && chain[0].Source !== null
            ? BaseItemTypes.PROJECTION
            : chain[0].Identity.Kind === 0
            ? BaseItemTypes.SELECTION
            : BaseItemTypes.LIST,
        SrcType: chain[0].Identity.Source,
        DestType: chain[0].Identity.Destination,
      };
    }
  }

  switch (type) {
    case CellDataIdListEntityType.Jobs:
      source_jobs.value = [];
      sourceItemsDisplay.value = true;
      source_jobs.value = (await aux.getSourceJobs(ids)).data;
      break;
    case CellDataIdListEntityType.Persons:
      source_contacts.value = [];
      sourceItemsDisplay.value = true;
      source_contacts.value = (await aux.getSourcePersons(ids)).data;
      break;
    case CellDataIdListEntityType.StorageItems:
    case CellDataIdListEntityType.StorageItemMovements:
      resetPagination();
      entity_ids.value = [];
      sourceTableModel.value = {} as AnalyticsResultTableExtended;
      sourceTableDisplay.value = true;
      sourceTableModel.value = await aux.getSourceTable(ids);
      break;
    default:
      break;
  }
}

function onUpdatePagination() {}
function onSelectionUpdate(val: any) {
  selectedEntities.value = val;
}
function onUnSelectionUpdate(val: any) {
  unselectedEntities.value = val;
}
function onSelectedAllUpdate(val: any) {
  selectedAll.value = val;
}

// Вызывается из шелла по событию ячейки.
function open(ids: number[], type: number) {
  getSourceItems(ids, type as CellDataIdListEntityType);
}

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_query_table = _resolveComponent("query-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_dialog, {
      "no-shake": "",
      "full-width": false,
      modelValue: sourceItemsDisplay.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sourceItemsDisplay).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "inhdialog-container-narrow" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('source_projection_elements')), 1),
              _createVNode(_component_q_btn, {
                flat: "",
                round: "",
                icon: "close",
                size: "md",
                color: "accent",
                title: _ctx.$t('close_label'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (sourceItemsDisplay.value = false))
              }, null, 8, ["title"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              (source_jobs.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(source_jobs.value, (j, j_i) => {
                      return (_openBlock(), _createBlock(JobCard, {
                        job: j,
                        key: 'srcjob_' + j_i
                      }, null, 8, ["job"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (source_contacts.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(source_contacts.value, (con, con_i) => {
                      return (_openBlock(), _createBlock(PersonCard, {
                        person: con,
                        key: 'srccon_' + con_i
                      }, null, 8, ["person"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      "full-width": true,
      modelValue: sourceTableDisplay.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((sourceTableDisplay).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "inhdialog-container" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t('source_projection_elements')), 1),
              _createVNode(_component_q_btn, {
                flat: "",
                round: "",
                icon: "close",
                size: "md",
                color: "accent",
                title: _ctx.$t('close_label'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (sourceTableDisplay.value = false))
              }, null, 8, ["title"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_unref(aux).isTableLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_q_spinner_dots, {
                      color: "primary",
                      size: "2em"
                    })
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_query_table, {
                class: "full-width q-px-sm",
                "hide-panel": true,
                "src-element": projectionParentEl.value,
                "is-sector": true,
                "sector-entity-ids": entity_ids.value,
                paginationModel: pagination,
                "onUpdate:paginationModel": onUpdatePagination,
                selectedEverything: selectedAll.value,
                "onUpdate:selectedEverything": onSelectedAllUpdate,
                selectedEntities: selectedEntities.value,
                "onUpdate:selectedEntities": onSelectionUpdate,
                unselectedEntities: unselectedEntities.value,
                "onUpdate:unselectedEntities": onUnSelectionUpdate,
                onMovePage: () => {},
                onRefreshPage: _cache[3] || (_cache[3] = ($event: any) => (getSourceItems(entity_ids.value, entity_type.value))),
                modelValue: sourceTableModel.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sourceTableModel).value = $event))
              }, null, 8, ["src-element", "sector-entity-ids", "paginationModel", "selectedEverything", "selectedEntities", "unselectedEntities", "modelValue"]), [
                [_vShow, sourceTableModel.value && sourceTableModel.value.HeaderRow && projectionParentEl.value]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})